<template>
  <div class="hall-filter" v-if="!isMobileMode">
    <div class="filter-main">
      <div class="filter-header">
        <!-- <div @click="dian">地</div> -->
        <div class="filter-item"
             :class="{ active: showTypeFilter === true }"
             @click="showTypeFilter = !showTypeFilter; showSortFilter = false;">
          <span>{{momentType.text || currentType.text}}</span><i class="ri-arrow-down-s-fill"></i>
        </div>
        <div class="filter-item"
             :class="{ active: showSortFilter === true }"
             @click="showSortFilter = !showSortFilter; showTypeFilter = false;">
          <span>{{ momentSort.text || currentSort.text }}</span><i class="ri-arrow-down-s-fill"></i>
        </div>
      </div>
      <transition name="filter-panel">
        <div class="filter-list" v-show="showTypeFilter">
          <div class="list-item"
               v-for="item in typeList"
               :key="'pc' + item.value + item.text"
               @click="changeTypeFilter(item)">{{ item.text }}</div>
        </div>
      </transition>
      <transition name="filter-panel">
        <div class="filter-list" v-show="showSortFilter">
          <div class="list-item"
               v-for="item in sortList"
               :key="'pc-sort' + item.value + item.text"
               @click="changeSortFilter(item)">{{ item.text }}</div>
        </div>
      </transition>
    </div>
  </div>
  <van-dropdown-menu v-else>
    <van-dropdown-item v-model="type" :options="typeList" />
    <van-dropdown-item v-model="value" :options="sortList"/>
    <!-- <van-dropdown-item v-model="currentType.value" :options="typeList" @change="handleTypeChange"/> -->
    <!-- <van-dropdown-item v-model="currentSort.value" :options="sortList"  @change="handleSortChange"/> -->
  </van-dropdown-menu>
</template>

<script>
import Vue from "vue";
import _ from "lodash";
import Bus from "@/api/bus";
import { DropdownMenu, DropdownItem } from "vant";
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
export default {
  name: "HallFilter",
  props: {
    isMobileMode: {
      type: Boolean,
      default: false
    },
    momentType: {
      type: [Object],
      default () {
        return this.currentType
      }
    },
    momentSort: {
      type: [Object],
      default () {
        return this.currentSort
      }
    }
  },
  watch: {
    type(newVal) {
      let that = this;
      if (that.isMobileMode) {
        _.forEach(that.typeList, item => {
          if (item.value == newVal) {
            that.currentType = item;
            that.showTypeFilter = false;
            that.$emit("changeFilter", {
              type: that.currentType,
              sort: that.currentSort
            });
          }
        });
      }
    },
    value(newVal) {
      let that = this;
      if (that.isMobileMode) {
        _.forEach(that.sortList, item => {
          if (item.value == newVal) {
            that.currentSort = item;
            that.showTypeFilter = false;
            that.$emit("changeFilter", {
              type: that.currentType,
              sort: that.currentSort
            });
          }
        });
      }
    }
  },
  data() {
    return {
      showTypeFilter: false,
      showSortFilter: false,
      type: "2",
      value: "99",
      text: "1",
      // 当前类型
      currentType: {
        value: "2",
        text: "市级大厅"
      },
      typeList: [
        {
          value: "99",
          text: "所有类型"
        },
        {
          value: "2",
          text: "市级大厅"
        },
        {
          value: "3",
          text: "区县级大厅"
        },
        {
          value: "4",
          text: "镇街级大厅"
        },
        {
          value: "5",
          text: "社区级"
        }
      ],
      // 当前排序
      currentSort: {
        value: "99",
        text: "默认排序"
      },
      sortList: [
        {
          value: "99",
          text: "默认排序"
        },
        {
          value: "1",
          text: "按人流量排序"
        }
      ]
    };
  },
  methods: {
    changeTypeFilter(filterItem) {
      // const that = this
      this.currentType = filterItem;
      this.$emit("changeFilter", {
        type: this.currentType,
        sort: this.currentSort
      });
      this.showTypeFilter = false;
    },
    changeSortFilter(filterItem) {
      const that = this;
      that.currentSort = filterItem;
      that.showSortFilter = false;
      that.$emit("changeFilter", {
        type: that.currentType,
        sort: that.currentSort
      });
    },
    handleTypeChange(value) {
      let that = this;
      let item = that.typeList.find(item => {
        return item.value == value;
      });
      that.currentType = item;
      that.showTypeFilter = false;
      that.$emit("changeFilter", {
        type: that.currentType,
        sort: that.currentSort
      });
    },
    handleSortChange(value) {
      let that = this;
      let item = that.sortList.find(item => {
        return item.value == value;
      });
      that.currentSort = item;
      that.showSortFilter = false;
      that.$emit("changeFilter", {
        type: that.currentType,
        sort: that.currentSort
      });
    },
    reset() {
      const that = this;
      // 当前类型
      that.currentType = {
        value: "2",
        text: "市级大厅"
      };

      // 当前排序
      that.currentSort = {
        value: "99",
        text: "默认排序"
      };
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@style/_var.scss";
@import "~@style/_theme.scss";
.hall-filter {
  padding: $paddingVertical $paddingHorizontal;
  .filter-main {
    position: relative;
    .filter-header {
      height: 34px;
      padding: 1px;
      background-color: #e1e6ed;
      border-radius: 4px;
    }
    .filter-item {
      float: left;
      width: 50%;
      height: 100%;
      line-height: 32px;
      text-align: center;
      background-color: #f5f7fa;
      cursor: pointer;
      i {
        margin-left: 8px;
        color: $colorTextSecondary;
        vertical-align: middle;
      }
      &:first-child {
        border-top-left-radius: 2px;
        border-bottom-left-radius: 2px;
      }
      &:last-child {
        border-left: 1px solid #e1e6ed;
        border-top-right-radius: 2px;
        border-bottom-right-radius: 2px;
      }
      &.active {
        background-color: #fff;
      }
    }
    .filter-list {
      position: absolute;
      left: 0;
      top: 100%;
      width: 100%;
      padding: 8px 0;
      margin-top: -1px;
      background-color: #fff;
      border: 1px solid #e1e6ed;
      border-top: none;
      box-shadow: 0 2px 4px 0 #e7e7e7;
      border-radius: 0 0 4px 4px;
      .list-item {
        height: 36px;
        line-height: 36px;
        text-align: center;
        cursor: pointer;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        &:hover {
          color: $colorPrimary;
          background: #f5f7fa;
        }
      }
    }
  }
}
/* filter-panel transition */
.filter-panel-enter-active {
  transition: all 0.3s;
}

.filter-panel-enter,
.filter-panel-leave-active {
  opacity: 0;
  transform: translateY(16px);
}

.filter-panel-move {
  transition: all 0.3s;
}

.filter-panel-leave-active {
  position: absolute;
  transition: all 0.3s;
}
</style>
